module.exports = __webpack_public_path__ + "static/6305-woodrose-58-077d74c6936d205f72eb39b90810ae86.jpg";